import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import moment from 'moment/min/moment-with-locales';
import Moment from 'react-moment';

Moment.globalMoment = moment;
Moment.globalLocale = 'ru';
Moment.globalFormat = 'DD.MM.YYYY';

ReactDOM.render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js